<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-icon @click="showConfig()">settings</v-icon>
              </v-card-title>
              <v-card-text>
                <div class="layout column align-center">
                  <img @dblclick="demo()" src="/static/xlogo.png" alt="PO Analyze" width="120" height="120">
                  <h1 class="flex my-4 primary--text">Pack Ship Manage</h1>
                </div>
                <v-form ref="login">
                  <v-text-field
                    append-icon="person"
                    name="username"
                    :label="$t('profile.username')"
                    type="text"
                    v-model="model.username"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    :label="$t('profile.password')"
                    id="password"
                    type="password"
                    v-model="model.password"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-form>
                <div class="error--text caption" >
                   {{ this.errMessage }}
                  </div>
              </v-card-text>
              <v-card-actions>
                <v-btn block color="primary" @click="handelLogin" :loading="loading">{{ $t("signIn")}}</v-btn>
                <v-spacer></v-spacer>
                <!-- <v-btn  @click="test">lang</v-btn> -->
                <v-menu offset-y>
                <template slot="activator">
                  <v-btn >
                    <v-icon left>language</v-icon>
                    {{ languageLabel }}
                    <v-icon >arrow_drop_down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="lang in langList"
                    :key="lang.code"
                    @click="switchLanguage(lang.code)"
                  >
                    <v-list-tile-title>{{ lang.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-dialog v-model="showConfigDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Config</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="APIURL" label="API URL" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="PROVIDER" label="Provider"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="DATABASE" label="Database" persistent-hint required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="showConfigDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="saveConfig()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters,mapState, mapActions } from "vuex";
import lang from "@/api/language"

import userService from "@/services/UserService"

export default {
  data: () => ({
    langList: lang,
    loading: false,
    showConfigDialog: false,
    APIURL: "",
    PROVIDER: "",
    DATABASE: "",
    errMessage: "",
    model: {
      username: "",
      password: ""
    },
    rules: {
          required: value => !!value || 'Required.'
    }
  }),
  computed: {
    ...mapGetters("source", ["getApiUrl"]),
    ...mapGetters("app", ["languageSelected"]),
    ...mapState("authen", ["loginSuccess", "loginErrorMsg"]),
    languageLabel(){
      let tmpLang = this.langList.find((lang) => {
        return lang.code == this.languageSelected
      })
      return tmpLang.label;
    }
  },
  created() {
    
    if (localStorage.API_URL) {
      this.APIURL = localStorage.API_URL;
    }
    if (localStorage.PROVIDER) {
      this.PROVIDER = localStorage.PROVIDER;
    }
    if (localStorage.DATABASE) {
      this.DATABASE = localStorage.DATABASE;
    }
  },
  methods: {
    ...mapActions("authen", ["login"]),
    ...mapActions("authen", ["getUserDetail"]),
    ...mapActions("source", ["setSource"]),
    ...mapActions("app", ["setLanguage"]),

    switchLanguage(lang){
      this.setLanguage(lang);
      this.$i18n.locale = lang
      localStorage.setItem("lang", lang)
    },
    demo(){
      this.APIURL = "http://smldemo.smlsoft.com:8081";
      this.PROVIDER = "MAINTEST";
      this.DATABASE = "bazaarb";

      this.model.username = '001'
      this.model.password = '001'

      localStorage.API_URL = this.APIURL;
      localStorage.PROVIDER = this.PROVIDER;
      localStorage.DATABASE = this.DATABASE;
      this.setSource({apiUrl: this.APIURL, provider: this.PROVIDER, database: this.DATABASE})
      
      alert("on:demo")
    },
    showConfig() {
      this.showConfigDialog = true;
    },
    saveConfig() {
      this.APIURL = this.formatUrl(this.APIURL)

      localStorage.API_URL = this.APIURL;
      localStorage.PROVIDER = this.PROVIDER;
      localStorage.DATABASE = this.DATABASE;
      
      this.setSource({apiUrl: this.APIURL, provider: this.PROVIDER, database: this.DATABASE})

      this.showConfigDialog = false;
    },
    formatUrl(url){
      let regCheckHttp = new RegExp("://", "i"); // ^(http|https)://
      if(!regCheckHttp.test(url)){
        url = "http://"+url
      }

      if(url.charAt(url.length - 1) == '/'){
        url = url.substring(0, url.length - 2)
      }
      return url
    },
    async handelLogin() {
      if (!this.$refs.login.validate()) {
        return;
      }
      
      localStorage.removeItem("_token");
      this.loading = true;

      await this.login({
        username: this.model.username,
        password: this.model.password
      });
      this.loading = false;
      if (this.loginSuccess) {
        this.getUserDetail();
        this.$router.push("/dashboard");
      } else {
        this.errMessage = this.loginErrorMsg;
      }
      
    }
  }
};
</script>

<style lang="css" scoped>
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
